(function () {
  'use strict';

  var STEPS = ['brand', 'equipment', 'model', 'partType'];
  var STEP_LABELS = ['Brand', 'Equipment', 'Model', 'Part type'];

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getData() {
    return window.TCB_PARTS_FINDER_DATA || {};
  }

  function buildSearchUrl(state) {
    var data = getData();
    var base = (data.brandCollections && data.brandCollections[state.brand]) || '/collections/shop-all-parts';
    var partType = (data.partTypes || []).find(function (p) { return p.id === state.partType; });
    var params = new URLSearchParams();
    if (state.model) params.set('q', state.model);
    if (partType && partType.searchHint) params.set('q', (params.get('q') || '') + ' ' + partType.searchHint).trim();
    var qs = params.toString();
    return qs ? base + '?' + qs : base;
  }

  function buildExpertUrl(state) {
    var params = new URLSearchParams({
      topic: 'parts',
      brand: state.brand || '',
      equipment: state.equipmentLabel || '',
      model: state.model || '',
      part_type: state.partTypeLabel || ''
    });
    return '/pages/contact?' + params.toString() + '#tcb-contact-form';
  }

  function PartsFinder(root) {
    this.root = root;
    this.shell = root.querySelector('[data-tcb-parts-shell]');
    this.flowMount = root.querySelector('[data-tcb-parts-flow]');
    this.resultsMount = root.querySelector('[data-tcb-parts-results]');
    this.stepIndex = 0;
    this.state = { brand: '', equipment: '', equipmentLabel: '', model: '', partType: '', partTypeLabel: '' };
    this.bind();
    this.render();
  }

  PartsFinder.prototype.bind = function () {
    var self = this;
    this.root.querySelector('[data-tcb-parts-start]').addEventListener('click', function () {
      self.shell.scrollIntoView({ behavior: 'smooth', block: 'start' });
      self.stepIndex = 0;
      self.state = { brand: '', equipment: '', equipmentLabel: '', model: '', partType: '', partTypeLabel: '' };
      self.resultsMount.hidden = true;
      self.shell.hidden = false;
      self.render();
    });
  };

  PartsFinder.prototype.render = function () {
    var self = this;
    var data = getData();
    var stepId = STEPS[this.stepIndex];
    var progress = STEP_LABELS.map(function (label, i) {
      return '<span class="' + (i === self.stepIndex ? 'is-active' : '') + '">' + escapeHtml(label) + '</span>';
    }).join('');

    var body = '';
    if (stepId === 'brand') {
      body = this.renderOptions((data.brands || []).map(function (b) { return { value: b, label: b }; }), 'brand');
    } else if (stepId === 'equipment') {
      body = this.renderOptions((data.equipmentTypes || []).map(function (e) {
        return { value: e.id, label: e.label };
      }), 'equipment');
    } else if (stepId === 'model') {
      body =
        '<p>Enter the model number from your machine label or manual cover.</p>' +
        '<input class="tcb-parts-finder-input" type="text" data-model-input placeholder="e.g. T300, 2008CS, Focus II" value="' +
        escapeHtml(this.state.model) +
        '" aria-label="Model number">' +
        '<div class="tcb-parts-finder-nav">' +
        '<button type="button" class="tcb-page-btn tcb-page-btn--secondary" data-back>Back</button>' +
        '<button type="button" class="tcb-page-btn tcb-page-btn--primary" data-next>Continue</button>' +
        '</div>';
    } else if (stepId === 'partType') {
      body = this.renderOptions((data.partTypes || []).map(function (p) {
        return { value: p.id, label: p.label };
      }), 'partType', true);
    }

    this.flowMount.innerHTML =
      '<div class="tcb-parts-finder-progress" aria-label="Progress">' + progress + '</div>' +
      '<div class="tcb-parts-finder-step">' + body + '</div>';

    this.flowMount.querySelectorAll('[data-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var value = btn.getAttribute('data-value');
        var label = btn.getAttribute('data-label');
        if (key === 'equipment') {
          self.state.equipment = value;
          self.state.equipmentLabel = label;
        } else if (key === 'partType') {
          self.state.partType = value;
          self.state.partTypeLabel = label;
        } else {
          self.state[key] = value;
        }
        if (key === 'partType') {
          self.showResults();
        } else {
          self.stepIndex += 1;
          self.render();
        }
      });
    });

    var back = this.flowMount.querySelector('[data-back]');
    if (back) back.addEventListener('click', function () { self.stepIndex -= 1; self.render(); });

    var next = this.flowMount.querySelector('[data-next]');
    if (next) {
      next.addEventListener('click', function () {
        var input = self.flowMount.querySelector('[data-model-input]');
        self.state.model = (input && input.value || '').trim();
        self.stepIndex += 1;
        self.render();
      });
    }
  };

  PartsFinder.prototype.renderOptions = function (options, key, isLast) {
    var self = this;
    var gridClass = options.length > 6 ? ' tcb-parts-finder-options--grid' : '';
    var html =
      '<h2>' + escapeHtml(this.stepTitle(key)) + '</h2>' +
      '<div class="tcb-parts-finder-options' + gridClass + '">';
    options.forEach(function (opt) {
      html +=
        '<button type="button" class="tcb-parts-finder-option" data-option data-key="' +
        escapeHtml(key) +
        '" data-value="' +
        escapeHtml(opt.value) +
        '" data-label="' +
        escapeHtml(opt.label) +
        '">' +
        escapeHtml(opt.label) +
        '</button>';
    });
    html += '</div>';
    if (!isLast) {
      html +=
        '<div class="tcb-parts-finder-nav">' +
        (self.stepIndex > 0 ? '<button type="button" class="tcb-page-btn tcb-page-btn--secondary" data-back>Back</button>' : '') +
        '</div>';
    }
    return html;
  };

  PartsFinder.prototype.stepTitle = function (key) {
    if (key === 'brand') return 'What brand is your equipment?';
    if (key === 'equipment') return 'What type of equipment?';
    if (key === 'partType') return 'What part do you need?';
    return 'Find your part';
  };

  PartsFinder.prototype.showResults = function () {
    var searchUrl = buildSearchUrl(this.state);
    var expertUrl = buildExpertUrl(this.state);
    this.shell.hidden = true;
    this.resultsMount.hidden = false;
    this.resultsMount.innerHTML =
      '<div class="tcb-wrap">' +
      '<h2>Parts search for your machine</h2>' +
      '<p class="tcb-parts-finder-summary">' +
      escapeHtml(this.state.brand) +
      ' · ' +
      escapeHtml(this.state.equipmentLabel) +
      (this.state.model ? ' · Model ' + escapeHtml(this.state.model) : '') +
      ' · ' +
      escapeHtml(this.state.partTypeLabel) +
      '</p>' +
      '<div class="tcb-parts-finder-actions">' +
      '<a class="tcb-page-btn tcb-page-btn--primary" href="' +
      escapeHtml(searchUrl) +
      '">Browse matching parts</a>' +
      '<a class="tcb-page-btn tcb-page-btn--secondary" href="' +
      escapeHtml(expertUrl) +
      '">Request part lookup</a>' +
      '<button type="button" class="tcb-page-btn tcb-page-btn--secondary" data-restart>Start over</button>' +
      '</div>' +
      '<div class="tcb-parts-finder-note">' +
      '<strong>Can’t find the exact part?</strong> Our team can confirm OEM numbers, alternates, and compatibility before you order. ' +
      'Photo upload and serial-number lookup are coming in the next release.' +
      '</div>' +
      '</div>';

    var self = this;
    this.resultsMount.querySelector('[data-restart]').addEventListener('click', function () {
      self.root.querySelector('[data-tcb-parts-start]').click();
    });

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'part_lookup_completed',
        part_brand: self.state.brand,
        part_equipment: self.state.equipment,
        part_type: self.state.partType
      });
    }
  };

  function boot() {
    var root = document.querySelector('[data-tcb-parts-finder]');
    if (!root) return;
    var url = window.TCB_PARTS_FINDER_DATA_URL;
    if (!url) {
      new PartsFinder(root);
      return;
    }
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        window.TCB_PARTS_FINDER_DATA = data;
        new PartsFinder(root);
        if (window.dataLayer) window.dataLayer.push({ event: 'part_lookup_started' });
      })
      .catch(function () {
        new PartsFinder(root);
      });
  }

  document.addEventListener('DOMContentLoaded', boot);
})();
